
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.347 10.291c.179 0 .328-.06.448-.18l3.151-3.085a.822.822 0 00.185-.25.669.669 0 00.057-.277.759.759 0 00-.06-.282.744.744 0 00-.182-.246l-3.15-3.08a.608.608 0 00-.449-.18c-.12 0-.23.028-.327.085a.657.657 0 00-.235.23.638.638 0 00.119.795L6.663 6.5 3.903 9.17a.667.667 0 00-.207.48.646.646 0 00.65.642z","fill":"#757F8A"}})])
          )
        }
      }
    